<ul class="nav domain-nav ps-3 pe-3 top-content">
  <li class="nav-title row">
    <span class="col">Domains</span
    ><span class="col"
      ><button
        class="pull-right btn-transparent"
        (click)="refreshDomains()"
        (keydown.enter)="refreshDomains()">
        <i class="fa fa-refresh text-primary">&nbsp;</i>
      </button></span
    >
  </li>
  <li>
    <input
      class="form-control domain-filter"
      type="text"
      #filter
      (keyup)="onFilterChange(filter.value)" />
  </li>
  @if (filter.value.length > 0 && filter.value.length < minFilterLength) {
    <small class="text-danger"
      >The search text must contain at least
      {{ minFilterLength }} characters</small
    >
  }
</ul>
<ul class="nav domain-nav ps-3 pe-3 scrollablecontent">
  @if (isLoading$ | async) {
    <div class="loading">Loading</div>
  }
  <ng-template #domainTreeItems let-items>
    @if (items?.domainTree[0].hidden && !items.hasOwnProperty('nested')) {
      <li>
        <p class="text-primary">No domains found</p>
      </li>
    }
    @for (item of items?.domainTree; track item) {
      <span class="domaintree-list-holder">
        @if (!item.hidden) {
          <li
            class="nav-item domain-list-item"
            [class.open]="item.open"
            [class.d-none]="item.hidden"
            [id]="initTimestamp + item.code"
            [attr.data-cy]="item.code">
            <div
              class="d-flex"
              [ngClass]="{
                'pinned text-primary': items?.activeDomain === item.code,
              }">
              @if (item.hasOwnProperty('children') && item.children.length) {
                <button
                  class="p-0 btn-transparent text-dark"
                  (click)="item.open = !item.open"
                  (keydown.enter)="item.open = !item.open"
                  type="button">
                  <i
                    class="fa-regular fa-lg"
                    [ngClass]="item.open ? 'fa-minus-square' : 'fa-plus-square'"
                    >&nbsp;</i
                  >
                </button>
              }
              @if (!item.hasOwnProperty('children') || !item.children.length) {
                <span class="ps-2 pe-1"
                  ><i class="fa fa-lg" [ngClass]="'fa-angle-right'"
                    >&nbsp;</i
                  ></span
                >
              }
              <span
                class="me-auto"
                title="{{ item.name }}"
                [innerHTML]="
                  item.code
                    | highlight
                      : highlight$.value
                      : minFilterLength
                      : initTimestamp + '-result-anchor'
                "
                (click)="pin(item)"
                (keydown.enter)="pin(item)"></span>
              <button
                class="hover-btn btn-transparent text-primary flex-last"
                type="button"
                (click)="pin(item)"
                (keydown.enter)="pin(item)">
                <i class="icon icon-pin"></i>
              </button>
            </div>
            @if (item.hasOwnProperty('children') && item.open) {
              <ul class="nav">
                <!-- recursive part -->
                <ng-container
                  *ngTemplateOutlet="
                    domainTreeItems;
                    context: {
                      $implicit: {
                        domainTree: item.children,
                        activeDomain: items.activeDomain,
                        nested: true,
                      },
                    }
                  "></ng-container>
              </ul>
            }
          </li>
        }
      </span>
    }
  </ng-template>
  <ng-container
    *ngTemplateOutlet="
      domainTreeItems;
      context: {$implicit: domains$ | async}
    "></ng-container>
</ul>
